import React from 'react';
import styles from './Footer.module.css';
import { Nav, Container } from 'react-bootstrap';
import { usePathname, useRouter } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';
import SSPIcon from '@/public/SSPIcon.png';

const Footer = () => {
	const currentYear = new Date().getFullYear();
	const router = useRouter();
	const pathname = usePathname();

	return (
		<footer className={styles.footer}>
			<Container>
				<div className={styles['footer-content']}>
					<a className={styles.logo} onClick={() => router.push('/')}>
						<Image
							src={SSPIcon}
							alt="Logo"
							width={50}
							height={50}
						/>
					</a>
					<div className={styles['footer-links']}>
						<Nav>
							<Link href="/" className={pathname === '/' ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']}>Home</Link>
							{/*<Link href="/features" className={pathname === '/features' ? `${styles["nav-link"]} ${styles.active}` : styles["nav-link"]}>Features</Link>*/}
						</Nav>
						<Nav>
							<Link href="/pricing" className={pathname === '/pricing' ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']}>Pricing</Link>
							<Link href="/contact" className={pathname === '/contact' ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']}>Contact Us</Link>
							<Link href="/privacy-policy" className={pathname === '/privacy-policy' ? `${styles['nav-link']} ${styles.active}` : styles['nav-link']}>Privacy Policy</Link>
						</Nav>
					</div>
					<div className={styles['copyright-text']}>
						&copy; {currentYear} Supply Sense Pro. All rights reserved.
					</div>
				</div>
			</Container>
		</footer>
	);
};

export default Footer;